export const CHANGE_SEARCHFIELD = "CHANGE_SEARCHFIELD";
